import update from 'immutability-helper';
import { REQUEST_BUSINESS_ACCOUNTS, SET_BUSINESS_ACCOUNTS } from './business-accounts-actions';

const initialState = {
  isFetching: false,
  list: [],
  byId: {}
};

function businessAccountsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_BUSINESS_ACCOUNTS: {
      return update(state, {
        isFetching: {$set: false},
        list: {$set: action.payload.list},
        byId: {$set: action.payload.byId}
      })
    }
    case REQUEST_BUSINESS_ACCOUNTS:
      return update(state, {
        isFetching: {$set: true}
      });
    default:
      return state
  }
}

export default businessAccountsReducer;



// WEBPACK FOOTER //
// ./src/components/business-accounts/business-accounts-reducer.js